import styled, { css } from 'styled-components';

import { media } from 'styles/utils';
import { ContentContainer } from 'common/layout';

export const CarouselContainer = styled(
  ContentContainer,
)<CarouselContainerProps>`
  position: static;
  padding: 0 0 40px 0;
  max-width: 100vw;
  grid-column: 1/3;
  grid-row: 2/3;

  ${media.desktop`
    display: none;
  `}

  .swiper {
    width: 100%;
  }

  .swiper-wrapper {
    box-sizing: border-box;
    width: min-content;
    // Add 1px padding top to show the shadow of the cards
    padding: 1px 0 72px;
  }

  .swiper-slide {
    display: flex;
    width: fit-content;
  }

  .swiper-slide:nth-child(4) {
    margin-right: 24px;
  }

  .swiper-button-next {
    right: 24px;
  }

  .swiper-button-prev {
    left: 24px;
  }

  .swiper-button-prev path,
  .swiper-button-next path {
    fill: ${({ theme }) => theme.colors.white};
  }

  .swiper-button-prev:hover,
  .swiper-button-next:hover {
    background-color: ${({ theme }) => theme.colors.primaryDeep};
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    bottom: 8px;
    top: auto;
    background-color: ${({ theme }) => theme.colors.primaryDeep};
    border: 2px solid ${({ theme }) => theme.colors.primaryDeep};
    width: 40px;
    height: 40px;
    padding: 0;
  }

  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    background: transparent;
    border: 2px solid ${({ theme }) => theme.colors.primaryDeep};
    opacity: 1;
  }

  .swiper-button-prev.swiper-button-disabled path,
  .swiper-button-next.swiper-button-disabled path {
    fill: ${({ theme }) => theme.colors.primaryDeep};
  }

  .swiper-button-disabled:focus,
  .swiper-button-disabled:hover {
    background: transparent;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    content: none;
  }

  .swiper-pagination-bullets,
  .swiper-pagination-horizontal {
    left: -6px !important;
  }

  .swiper-pagination-bullet {
    width: 20px;
    height: 16px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    opacity: 0.2;
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
  }

  ${({ $variant }) =>
    $variant === 'white' &&
    css`
      .swiper-button-prev,
      .swiper-button-next {
        background-color: ${({ theme }) => theme.colors.white};
        border: 2px solid ${({ theme }) => theme.colors.white};
      }

      .swiper-button-prev:hover,
      .swiper-button-next:hover {
        background-color: ${({ theme }) => theme.colors.white};
      }

      .swiper-button-prev path,
      .swiper-button-next path {
        fill: ${({ theme }) => theme.colors.primaryDeep};
      }

      .swiper-button-prev.swiper-button-disabled,
      .swiper-button-next.swiper-button-disabled {
        border: 2px solid ${({ theme }) => theme.colors.white};
      }

      .swiper-button-prev.swiper-button-disabled:hover,
      .swiper-button-next.swiper-button-disabled:hover,
      .swiper-button-prev.swiper-button-disabled:focus,
      .swiper-button-next.swiper-button-disabled:focus {
        background-color: ${({ theme }) => theme.colors.primaryDeep};
      }

      .swiper-button-prev.swiper-button-disabled path,
      .swiper-button-next.swiper-button-disabled path {
        fill: ${({ theme }) => theme.colors.white};
      }
    `}
`;

type CarouselContainerProps = {
  $variant?: 'white';
};

export const CarouselWrapper = styled.div`
  flex-direction: column;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
  position: relative;

  ${media.desktop`
    flex-direction: row;
    min-height: 343px;
    height: auto;
    margin: 0 30px;
    width: calc(100% - 60px);
  `}
`;

export const CarouselPaginationItem = styled.div<CarousePaginationItemProps>`
  background: transparent;

  & svg {
    // Create random rotation
    transform: ${({ index }) =>
      `rotate(${Math.floor(Math.random() * (180 - 0) + 0 * index * 100)}deg)`};
    height: 16px;
    width: 16px;
    background: transparent;
  }
`;

type CarousePaginationItemProps = {
  index: number;
};
